export const EMAIL_DIALOG_BODY_MIN_ROWS = 8;
